<template>
  <div class="bookshelf">
    <Head title="我的书架" />
    <van-tabs v-model="active" color="#4A79F1">
      <van-tab title-class="tab-item" title="图书">
        <Books />
      </van-tab>
      <van-tab title-class="tab-item" title="行业报告">
        <Reports />
      </van-tab>
      <van-tab title-class="tab-item" title="论文">
        <ConferencePaper></ConferencePaper>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Head from "../components/headTabs.vue";
import Books from "./books.vue";
import Reports from "./reports.vue";
import ConferencePaper from "./conferencePaper.vue";
export default {
  name: "bookshelf",
  components: {
    Head,
    Books,
    Reports,
    ConferencePaper
  },
  data() {
    return {
      active: 0,
    };
  },
};
</script>

<style lang="scss" scoped>
.bookshelf {
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
}
</style>